import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Divider,
  Button,
  Card,
  Popconfirm,
  Collapse,
  Form,
  Input,
  Row,
  Col,
  Space,
  Badge,
  Select,
} from "antd";
import * as Icon from "react-feather";
import { useDispatch } from "react-redux";
import appLoaderAction from "../../redux/action/app-loader-action";
import notifyUtitls from "../../utils/notify-utils";
import CustomTable from "../../components/table/custom-table";
import { useCreatedSort, withCreatedColumn } from '../../shared/functional/created-sort';
import AddEditNewsDialog from "./AddEditNewsDialog";
import newService from "../../services/new-service";
import constantService from "../../services/constant-service";
import { createSelector } from "reselect";
import userService from "../../services/user-service";

const { Panel } = Collapse;
const { Option } = Select;

const News = () => {
  const dispatch = useDispatch();
  const [isShowAddFileDialog, setIsShowAddFileDialog] = useState(false);
  const [editData, setEditData] = useState(null);
  const [condition, setCondition] = useState({
    title: null,
    status: null,
  });
  const [dataList, setDataList] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    rowPerPage: 10,
    rowCount: 0,
  });
  const [newsType, setNewsType] = useState(null);
  const [groupMenu, setGroupMenu] = useState(null);
  const [constant, setConstant] = useState({});
  const [userList, setUserList] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // const [selectedRows, setSelectedRows] = useState([]);

  /*
    NMU-580: the วันที่/เวลาสร้าง column and the sort behind it.

    The server does the ordering — this table shows one page of many — so a
    click re-runs the search in the new order, back on page 1: the newest
    record is not on page 3 of the same list read the other way round.
  */
  const { sort, createdColumn, onChangeTable } = useCreatedSort((next) =>
    doSearch(1, { condition, groupMenu, newsType, sort: next }));

  const columns = [
    {
      key: "title",
      align: "left",
      title: "หัวข้อข่าว",
      dataIndex: "title",
      render: (text) => <span>{text.titleTH}</span>,
    },
    {
      key: "shortDescription",
      title: "คำอธิบาย",
      dataIndex: "shortDescription",
      render: (text) => <span>{text.descriptionTH}</span>,
    },
    {
      title: "จำนวนผู้เข้าชม",
      dataIndex: "totalView",
      key: "totalView",
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (status) =>
        status ? (
          <Badge color="#4A9A0F" className="text-nowrap" text="Online" />
        ) : (
          <Badge color="#C0C0C0" className="text-nowrap" text="Offline" />
        ),
    },
    {
      title: "ผู้บันทึก",
      dataIndex: "createBy",
      key: "createBy",
      render: (createBy) => {
        let check = userList.find((user) => createBy === user.userId);
        if (check) {
          return `${check.profile?.firstName} ${check.profile?.lastName}`;
        } else {
          return `undefined`;
        }
      },
    },
    {
      title: "ผู้แก้ไข",
      dataIndex: "updateBy",
      key: "updateBy",
      render: (updateBy) => {
        let check = userList.find((user) => updateBy === user.userId);
        if (check) {
          return `${check.profile?.firstName} ${check.profile?.lastName}`;
        } else {
          return `undefined`;
        }
      },
    },

    {
      title: "ดำเนินการ",
      key: "action",
      render: ({ newsId }) => (
        <Space size="middle">
          <label
            style={{ cursor: "pointer" }}
            onClick={() => onClickEdit(newsId)}
            className="pe-3 border-end"
          >
            <Icon.Edit size={18} />
          </label>

          <Popconfirm
            title="ยืนยันการลบข้อมูล ?"
            onConfirm={() => onConfirmDelete(newsId)}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
          >
            <label style={{ cursor: "pointer" }}>
              <Icon.Trash size={18} />
            </label>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    async function initData() {
      const response = await constantService.getConstants();
      const responseUser = await userService.search();

      setUserList(responseUser.list);
      setConstant(response.constants);
    }
    initData();
    doSearch();
  }, []);

  useEffect(() => {
    if (editData) {
      onEdit(editData);
    }
  }, [editData]);

  /**
   * @param currentPage page to land on, 1 to start over.
   * @param overrides   NMU-529: search with these filters instead of the ones in
   *   state. setCondition only takes effect on the next render, so a caller that
   *   resets the filters and searches in the same handler would otherwise re-run
   *   the search it just cleared.
   */
  const doSearch = async (currentPage, overrides) => {
    try {
      const activeSort = overrides && overrides.sort ? overrides.sort : sort;
      const newPaginate = {
        ...pagination,
        currentPage: currentPage ? currentPage : pagination.currentPage,
        // NMU-580: the order travels with the page — see created-sort.js.
        ...activeSort,
      };

      dispatch(appLoaderAction.enable());

      const activeCondition = overrides ? overrides.condition : condition;
      const activeGroupMenu = overrides ? overrides.groupMenu : groupMenu;
      const activeNewsType = overrides ? overrides.newsType : newsType;

      // NMU-533: keywordList is no longer a search condition. The backend skips
      // the criterion when it is absent, so nothing else changes.
      const newCondition = {
        title: activeCondition.title,
        newsType: activeNewsType,
        groupMenuList: activeGroupMenu ? [activeGroupMenu] : null,
        status: activeCondition.status,
        createBy: activeCondition.createBy,
      };
      const result = await newService.search(newCondition, newPaginate);
      // setDataList(result.list);
      setDataList([...result.list]);
      setPagination(result.pagination ? result.pagination : newPaginate);
      setSelectedRowKeys([]);
      // setSelectedRows([]);

      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  const onChangeCondition = (event) => {
    const { name, value } = event.target;
    setCondition({ ...condition, [name]: value });
  };

  /**
   * NMU-529: clearing the filters has to re-run the search, not just empty the
   * inputs — otherwise the table keeps showing the previous result set while the
   * form claims no filter is applied. Back to page 1, since the record the user
   * was looking at on page 3 of a filtered list is somewhere else entirely in
   * the full one.
   */
  const onClearSearch = () => {
    const cleared = { title: null, status: null, createBy: null };
    setCondition(cleared);
    setGroupMenu(null);
    setNewsType(null);
    // NMU-529: no `setDataList(null)`. Emptying the table by hand was this
    // page's way of hiding the stale result set; re-running the search
    // replaces it with the real one instead of blanking it.
    doSearch(1, { condition: cleared, groupMenu: null, newsType: null });
  };

  const onChangePage = (currentPage) => {
    doSearch(currentPage);
  };

  const onAdd = () => {
    setEditData(null);
    setIsShowAddFileDialog(true);
  };

  const onClickEdit = async (id) => {
    try {
      dispatch(appLoaderAction.enable());
      const editData = await newService.getById({ id: id });
      onEdit(editData.bean);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const onEdit = (data) => {
    setEditData(data);
    setIsShowAddFileDialog(true);
  };

  const onSaveComplete = () => {
    setEditData(null);
    setIsShowAddFileDialog(false);
    doSearch();
  };

  const onCancel = () => {
    setIsShowAddFileDialog(false);
    setEditData(null);
  };

  const onConfirmDelete = (id) => {
    onDelete(id);
  };

  const onDelete = async (id) => {
    try {
      dispatch(appLoaderAction.enable());
      await newService.remove({ deleteIds: [id] });
      dispatch(appLoaderAction.disale());
      notifyUtitls.deleted("สำเร็จ", "ลบข้อมูลสำเร็จ");
      doSearch();
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const rowSelection = () => {
    return {
      onChange: (selectedRowKeys, selectedRows) => {
        // setSelectedRows(selectedRows);
        setSelectedRowKeys(selectedRowKeys);
      },
      selectedRowKeys,
    };
  };

  const renderGroupMenuOption = () => {
    return constant.menuGroupType?.map((item) => {
      return (
        <Select.Option value={item.value} key={item.labelTh}>
          {item.labelTh}
        </Select.Option>
      );
    });
  };
  const renderNewsTypeOption = () => {
    const list = constant.newsType || [];
    // NMU-412: sub-types carry a main group; render them under OptGroups.
    // Falls back to a flat list if the API doesn't send grouping info.
    const hasGroups = list.some((item) => item.groupValue);
    if (!hasGroups) {
      return list.map((item) => (
        <Select.Option value={item.value} key={item.value}>
          {item.labelTh}
        </Select.Option>
      ));
    }
    const groups = [];
    const byKey = {};
    list.forEach((item) => {
      const key = item.groupValue;
      if (!byKey[key]) {
        byKey[key] = { label: item.groupLabelTh || key, items: [] };
        groups.push(byKey[key]);
      }
      byKey[key].items.push(item);
    });
    return groups.map((g) => (
      <Select.OptGroup label={g.label} key={g.label}>
        {g.items.map((item) => (
          <Select.Option value={item.value} key={item.value}>
            {item.labelTh}
          </Select.Option>
        ))}
      </Select.OptGroup>
    ));
  };

  const renderOptionUser = () => {
    return userList?.map((item) => {
      if (item?.profile) {
        const profile = item.profile;
        return (
          <Select.Option value={item.userId} key={item.userId}>
            {`${profile.firstName} ${profile.lastName}`}
          </Select.Option>
        );
      } else {
        return null;
      }
    });
  };

  const onChangeSelect = (name) => {
    return (value) => {
      setCondition({ ...condition, [name]: value });
    };
  };

  return (
    <div>
      <h2 className="color-primary-title">ข่าวสาร</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการเนื้อหา</Breadcrumb.Item>
        <Breadcrumb.Item>ข่าวสาร</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
      <div className="d-flex justify-content-between">
        <div>
          <Button type="primary" onClick={() => onAdd()}>
            <Icon.Plus className="me-1" size={18} /> เพิ่มข่าว
          </Button>
        </div>
      </div>
      <Card className="mt-4" bordered={false}>
        <Collapse className="mb-4" defaultActiveKey={["1"]}>
          <Panel header="ตัวกรอง" key="1">
            <div>
              <Form layout="vertical">
                <Row gutter={20}>
                  <Col span={7}>
                    <Form.Item label="หัวข้อข่าว" className="mb-0">
                      <Input
                        name="title"
                        value={condition.title}
                        onChange={onChangeCondition}
                      />
                    </Form.Item>
                  </Col>
                  {/* NMU-533: no คีย์เวิร์ด filter here. Keywords are something
                      an editor sets on a news item in the add/edit dialog — they
                      were never a useful way to find one. The dialog keeps its
                      keyword input. */}
                  <Col span={5}>
                    <Form.Item label="ประเภทข่าว" className="mb-0">
                      <Select
                        customWidth="100%"
                        name="newsType"
                        onChange={(value) => setNewsType(value)}
                        value={newsType}
                      >
                        <Select.Option value={null}>ทั้งหมด</Select.Option>
                        {renderNewsTypeOption()}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="กลุ่มผู้ใช้งาน" className="mb-0">
                      <Select
                        customWidth="100%"
                        name="groupMenuList"
                        onChange={(value) => setGroupMenu(value)}
                        value={groupMenu}
                      >
                        <Select.Option value={null}>ทั้งหมด</Select.Option>
                        {renderGroupMenuOption()}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={20}>
                  <Col span={5}>
                    <Form.Item label="ผู้บันทึก" className="mb-0">
                      <Select
                        showSearch
                        style={{ width: 200 }}
                        placeholder="Search to Select"
                        optionFilterProp="children"
                        allowClear
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={condition.createBy}
                        onChange={onChangeSelect("createBy")}
                      >
                        {renderOptionUser()}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="สถานะ" initialValue="">
                      <Select
                        name="status"
                        value={condition.status}
                        onChange={onChangeSelect("status")}
                      >
                        <Option value={null}>All</Option>
                        <Option value={true}>Online</Option>
                        <Option value={false}>Offline</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={20}>
                  <Col className="mt-4">
                    <Button
                      type="primary"
                      className="w-100"
                      onClick={() => doSearch()}
                    >
                      <Icon.Search className="me-1" size={18} /> ค้นหา
                    </Button>
                  </Col>
                  <Col className="mt-4">
                    <Button
                      className="btn-gray"
                      onClick={() => onClearSearch()}
                    >
                      ล้างค่า
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Panel>
        </Collapse>
        {/* rowSelection={{
            type: 'checkbox',
            ...rowSelection(),
          }} */}
        <CustomTable
          rowKey="newsId"
          tableName="newsTable"
          columns={withCreatedColumn(columns, createdColumn)}
          onChangeTable={onChangeTable}
          data={dataList}
          scroll={{ x: true }}
          isPagination={true}
          onChangePage={onChangePage}
          currentPage={pagination.currentPage}
          pageSize={pagination.rowPerPage}
          totalRecord={pagination.rowCount}
        />
      </Card>

      <AddEditNewsDialog
        isShow={isShowAddFileDialog}
        editData={editData}
        onCancel={onCancel}
        content={constant}
        renderNewsTypeOption={renderNewsTypeOption}
        renderGroupMenuOption={renderGroupMenuOption}
        onSaveComplete={onSaveComplete}
      ></AddEditNewsDialog>
    </div>
  );
};

export default News;
